<template>

<div class="contein">
  <br>
  <div class="text-center" style="margin-top: 2em">
    <h1 class="text-center text-white">Error 404</h1>
    <br>
    <h1 class="msg display-4">Página no encontrada </h1>
  </div>
  <div class="text-center">
    <b-button size="sm" to="/" variant="info"><i class="fa fa-arrow-left"></i> Ir a Inicio</b-button>
  </div>

  <div class="astro-wrap">
    <a class="astronaut" href="#" title="return to base"></a>
  </div>
  <h2 class="msg display-3 mr-4">..shhh.. ..houston... ..404... ..shhhh... ..lost.. ..in.. ..space. .shhhhh...</h2>
</div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
<style lang="css" scoped>
  .contein {
  width: 100%;

  font-size: 16px;
  line-height: 25px;
  font-weight: normal;
  background: url(https://i.imgur.com/bsqWdBi.jpg);
}

.msg {
  color: #fff;
  text-align: center;
  -webkit-animation: flicker 2s ease infinite;
          animation: flicker 2s ease infinite;
}

.astro-wrap {
  width: 265px;
  height: 530px;
  margin: 0 auto;
  position: relative;
}

.astronaut {
  background: url(https://i.imgur.com/VurcHkh.png);
  width: 265px;
  height: 429px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(0, 50px);
  -webkit-animation: move 10s infinite;
          animation: move 10s infinite;
}

@-webkit-keyframes move {
  0% {
    transform: translate(0, 50px);
  }
  50% {
    transform: translate(20px, 100px);
  }
  100% {
    transform: translate(0, 50px);
  }
}

@keyframes move {
  0% {
    transform: translate(0, 50px);
  }
  50% {
    transform: translate(20px, 100px);
  }
  100% {
    transform: translate(0, 50px);
  }
}
@-webkit-keyframes blink {
  0% {
    top: 50px;
    left: 0px;
  }
  50% {
    top: 100px;
    left: 20px;
  }
  100% {
    top: 50px;
    left: 0px;
  }
}
@keyframes blink {
  0% {
    top: 50px;
    left: 0px;
  }
  50% {
    top: 100px;
    left: 20px;
  }
  100% {
    top: 50px;
    left: 0px;
  }
}
@-webkit-keyframes flicker {
  0% {
    opacity: 0.9;
  }
  30% {
    opacity: 0.97;
  }
  40% {
    opacity: 1;
  }
  80% {
    opacity: 0.9;
  }
  88% {
    opacity: 0.98;
  }
  90% {
    opacity: 0.94;
  }
  93% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.99;
  }
  96% {
    opacity: 0.93;
  }
  98% {
    opacity: 1;
  }
  99% {
    opacity: 0.93;
  }
}
@keyframes flicker {
  0% {
    opacity: 0.9;
  }
  30% {
    opacity: 0.97;
  }
  40% {
    opacity: 1;
  }
  80% {
    opacity: 0.9;
  }
  88% {
    opacity: 0.98;
  }
  90% {
    opacity: 0.94;
  }
  93% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.99;
  }
  96% {
    opacity: 0.93;
  }
  98% {
    opacity: 1;
  }
  99% {
    opacity: 0.93;
  }
}
@media only screen and (max-width: 570px) {
  .msg {
    position: absolut;
  }
}
@media only screen and (min-width: 1900px) {
  .contein{
    background-size: cover;
  }
}
</style>
